import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Select } from '@ngxs/store';
import { Feature } from 'app/library/feature/models/feature.model';
import { FeatureState } from 'app/library/feature/models/feature.state';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { User } from 'app/projects/user/src/lib/models/user';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';

@Injectable()
export class EngageFeatureGuard extends UnsubscribeOnDestroy  {
    @Select(UserState.getMyInfo)
    profile$: Observable<User>;
    profile: User;

    @Select(FeatureState.getEntities)
    feature$: Observable<Feature[]>;

    constructor(private router: Router, private _tenantDataService: TenantDataService) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.profile$.pipe(takeUntil(this._unsubscribeAll)).subscribe((profile) => {
            this.profile = profile;
        });

        return this.feature$.pipe(
            filter((features) => !!features),
            map((features) => {
                const isEngageFeatureActive = !!features.filter((feature) => feature.id === 'engage' && feature.status === 'active').length;
                const isEngageHomeScreenFeatureActive = this._tenantDataService.isEngageHomeScreenFeatureActive;
                const toReturn = isEngageFeatureActive && isEngageHomeScreenFeatureActive && this.profile.assignedToExperience;

                if (!toReturn) {
                    this.router.navigateByUrl(`/modules`);
                }

                return toReturn;
            })
        );
    }
}
